module.exports = __webpack_public_path__ + "static/media/icon_shop.c430c554.svg";